import { render } from "react-dom";
import SpacesYouMayAlsoLike from ".";
import React from "react";
import { Provider } from "react-redux";
import { DesignContextProvider } from "Components/DesignContext";

export function init(model: Readonly<LSCommon.Service.LSWebUI.Models.XPP.XppLandingPageJsViewModel>) {
   const container = document.getElementById("xpp-spacesyoumayalsolike");
   if (!container) {
      return;
   }

   //Cross-selling should be applicable only for Proposed-Unclaimed venues
   if (model.VenueStatusNew == LSCrossTier.VenueStatusNew.Proposed) {
      render(<Provider store={LSStore.instance}>
         <DesignContextProvider name="primary">
            <SpacesYouMayAlsoLike latitude={model.VenueLatitude} longitude={model.VenueLongitude} />
         </DesignContextProvider>
      </Provider>, container);
   }
}
